import { useState } from 'react';
import services from 'src/services/Services';

export default function useAddUser(roles, dataUsers, getUsers) {
    const [open, setOpen] = useState(false);

    const [form, setForm] = useState({
        userName: "",
        email: "",
        name: "",
        lastName: "",
        rolID: "",
        rolName: "",
        IDCLIENTE: "",
        TIPOUSUARIO: "",
    });

    const [alert, setAlert] = useState({
        open: false,
        type: "success",
        message: ""
    });

    const tipoUsuarioOptions = [
        { label: "Cliente", value: "Cliente" },
        { label: "Icintracom", value: "Icintracom" }
    ];

    const rolOptions = roles.map(r => ({
        label: r.NAME,
        value: r.ID
    }));

    const showClientField = form.TIPOUSUARIO === "Cliente";

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const closeAlert = () => setAlert({ ...alert, open: false });

    const onSave = async () => {
        const userExists = dataUsers.some(
            u => u.USERNAME === form.userName || u.EMAIL === form.email
        );

        if (userExists) {
            setAlert({ open: true, type: "error", message: "El usuario ya existe." });
            return;
        }

        try {
            const bodyAdd = {
                name: form.name,
                short_name: form.userName,
                id_client: form.IDCLIENTE,
                email: form.email
            };

            const myRes = await services.addUserMysql(bodyAdd);
            const userID = myRes.data.id.IdCliente;

            // Agregar en Keycloak
            await services.addUser({
                enabled: true,
                firstName: form.name,
                lastName: form.lastName,
                email: form.email,
                username: form.userName,
                requiredActions: ["UPDATE_PASSWORD"],
                attributes: {
                    IDCLIENTE: [form.IDCLIENTE],
                    TIPOUSUARIO: [form.TIPOUSUARIO],
                    IDMYSQL: [userID]
                }
            }).then((response) => {
                const id = response?.data.userId
                onSetPassword(id)
            }).catch((error) => {
                if (error.response.status === 409) {
                    let body={
                        "IdCliente": userID
                    }
                    services.deleteUserMysql(body)
                }
                setAlert({ open: true, type: "error", message: "Error al agregar usuario." });
            })
        } catch (err) {
            setAlert({ open: true, type: "error", message: "Error al agregar usuario." });
        }
    };

    const onSetPassword = async (userID) => {
        const body = { type: "password", value: "icintracom", temporary: true };
        await services.resetPassword(userID, body);
        await onSetRolUser(userID);
    };

    const onSetRolUser = (userID) => {
        let body = [{
            "id": form.rolID,
            "name": form.rolName,
            "composite": false,
            "clientRole": true,
            "containerId": "2758d422-8dff-4b47-9706-40559e829d47"
        }]
        services.setRoleUser(userID, body).then(response => {
            onSetRolRealm(userID)
        }).catch(error => console.error("ICIntracom", error.message))
    }

    const onSetRolRealm = (userID) => {
        let body = [{
            "id": "fea79e94-0a22-4f44-af60-639c38f9f109",
            "name": "realm-admin",
            "composite": true,
            "clientRole": true,
            "containerId": "6c4c80bc-b84e-4c70-add3-6fc2f8803eed"
        }]
        services.setRoleRealm(userID, body).then(response => {
            setForm({
                userName: '',
                email: '',
                name: '',
                lastName: '',
                rolID: '',
                rolName: '',
                IDCLIENTE: '',
                TIPOUSUARIO: '',
                id_client: ''
            })

            setAlert({ open: true, type: "success", message: "Usuario agregado correctamente." });

            getUsers();
            handleClose();

        }).catch(error => console.error("ICIntracom", error.message))
    }

    return {
        open,
        handleOpen,
        handleClose,
        form,
        setForm,
        tipoUsuarioOptions,
        rolOptions,
        showClientField,
        onSave,
        alert,
        closeAlert
    };
}
